import { Injectable } from '@angular/core';
import {
  AuthService,
  ProductService,
  STOCK_STATUS,
  Availability,
  AvailabilityHelperService,
  AvailabilityDisplay,
  Product,
  GungAnonymousConfigService,
  MetadataService
} from 'gung-standard';
import { DateUtilService, GungLanguageConfigService } from 'gung-common';
import { TranslateService } from '@ngx-translate/core';
import { filter, first } from 'rxjs';
import { Observable, of } from 'rxjs';
import { environment } from './../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TyloAvailabilityHelperService extends AvailabilityHelperService {
  activeGroups: { [s: string]: boolean };

  // isHelo = environment.projectName === 'helo';

  currentProduct: Product;

  constructor(
    protected authService: AuthService,
    protected translateService: TranslateService,
    protected productService: ProductService,
    protected dateUtilService: DateUtilService,
    protected gungAnonymousConfigService: GungAnonymousConfigService,
    protected metadataService: MetadataService,
    protected languageConfigService: GungLanguageConfigService
  ) {
    super(authService, translateService, dateUtilService, gungAnonymousConfigService, metadataService, languageConfigService);
    this.authService
      .getCurrentUser()
      .pipe(
        filter(user => !!user),
        first()
      )
      .subscribe(user => {
        this.activeGroups = user.activeGroups;
      });
  }

  protected getValueFromStatus(status: STOCK_STATUS, isSales: boolean, availability: Availability): string {
    if (!availability) {
      return '';
    }
    let value: string;

    // user and sales will be the same info about availability
    if (status === STOCK_STATUS.IN_STOCK) {
      value = `${this.translateService.instant('IN_STOCK')} (${availability.currentAvailability})`;
    } else if (status === STOCK_STATUS.INCOMING) {
      const firstDate = Object.keys(availability.extra.availabilities).filter(key => {
        return availability.extra.availabilities[key] > 0;
      })[0];
      value = this.translateService.instant('EXPECTED_DATE', { date: firstDate });
    }

    if (status === STOCK_STATUS.OUT_OF_STOCK) {
      value = this.translateService.instant('OUT_OF_STOCK');
    }

    return value;
  }

  public getAvailabilityDisplay(availability: Availability, product: Product = null): Observable<AvailabilityDisplay> {
    if (this.activeGroups.NOPRICE) {
      return of({ value: '', class: { 'd-none': true } });
    }
    this.currentProduct = product;
    return super.getAvailabilityDisplay(availability, product);
  }
}
